const pageOptions = document.getElementById('page-options')

window.options = pageOptions ? JSON.parse(pageOptions.dataset.options || '{}') : {}

window.pageData = function (id) {
  const element = document.getElementById(id)

  return element ? JSON.parse(element.dataset.value || 'null') : null
}

window.escapeHtml = function (value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')
}

window.csrfToken = function () {
  return document.querySelector('meta[name="_token"]')?.getAttribute('content') ?? ''
}
